import { Injectable } from "@angular/core";
import { Router, NavigationEnd, ActivatedRouteSnapshot } from "@angular/router";
import { BehaviorSubject, filter } from "rxjs";
import { Breadcrumb } from "./breadcrumb.model"; // Assuming you have a Breadcrumb interface defined
@Injectable({ providedIn: "root" })
export class BreadcrumbService {
  private breadcrumbs = new BehaviorSubject<Breadcrumb[]>([]);
  breadcrumbs$ = this.breadcrumbs.asObservable();

  constructor(private router: Router) {
    this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      const root = this.router.routerState.snapshot.root;
      const crumbs = this.buildBreadcrumbs(root);
      this.breadcrumbs.next(crumbs);
    });

    const root = this.router.routerState.snapshot.root;
    const initialCrumbs = this.buildBreadcrumbs(root);
    this.breadcrumbs.next(initialCrumbs);
  }

  private buildBreadcrumbs(
    route: ActivatedRouteSnapshot,
    url: string = "",
    breadcrumbs: Breadcrumb[] = []
  ): Breadcrumb[] {
    const label = route.data["breadcrumb"];
    const path = route.url.map((segment) => segment.path).join("/");
    const nextUrl = path ? `${url}/${path}` : url;

    if (label) {
      breadcrumbs.push({
        label,
        url: nextUrl,
        isActive: route.children.length === 0,
      });
    }

    if (route.firstChild) {
      return this.buildBreadcrumbs(route.firstChild, nextUrl, breadcrumbs);
    }

    return breadcrumbs;
  }
}
